mergedInboundTracking